import React, { useState } from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

import Img from "gatsby-image"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTwitter,
  faLinkedin
} from '@fortawesome/free-brands-svg-icons'

import Paragraph from './components/Paragraph'
import CallToAction from './components/CallToAction'
import Popover from './components/Popover'

const Mission = () => {

    const [ showPopover, setShowPopover ] = useState(false)
    const [ popoverTitle, setPopoverTitle ] = useState('')
    const [ popoverBody, setPopoverBody ] = useState('')


     const data = useStaticQuery(graphql`
        query {
            allContentfulMission {
              edges {
                node {
                   paragraph1
                    paragraph1Keyword1
                    paragraph1Keyword2
                    paragraph1Keyword3
                    paragraph1Keyword4
                    paragraph2
                    paragraph2Keyword1
                    paragraph2Keyword2
                    paragraph2Keyword3
                    callToActionText
                    callToActionKeyword
                    callToActionButtonText
                    secondaryCallToActionButtonText
                    twitterLink
                    link1Description
                    linkedinLink
                    link2Description
                    headshotTitle
                    headshotDescription
                    headshot {
                        fluid(maxWidth: 200, 
                                quality: 100,
                                ){
                                ...GatsbyContentfulFluid
                            }
                  }
                }
              }
             
            }
        }
        `)

        const { paragraph1, 
            paragraph1Keyword1, 
            paragraph1Keyword2, 
            paragraph1Keyword3, 
            paragraph1Keyword4, 
            paragraph2, 
            paragraph2Keyword1, 
            paragraph2Keyword2, 
            paragraph2Keyword3, 
            callToActionText, 
            callToActionKeyword, 
            callToActionButtonText, 
            secondaryCallToActionButtonText, 
            twitterLink, 
            link1Description, 
            linkedinLink, 
            link2Description, 
            headshot, 
            headshotTitle, 
            headshotDescription } = data.allContentfulMission.edges[0].node

            let paragraph1KeywordArray = [ paragraph1Keyword1, paragraph1Keyword2, paragraph1Keyword3, paragraph1Keyword4 ]
            let paragraph2KeywordArray = [ paragraph2Keyword1, paragraph2Keyword2, paragraph2Keyword3 ]

            const handleHover = ( title, description ) => {
                setPopoverTitle(title)
                setPopoverBody(description)
                setShowPopover(true)
            }

    return (

         <section className="py-5 second-bg-color" id="mission">
            <Container
                id="mission-inner" className="py-5 d-flex justify-content-center align-items-center"
            >
                <Container className="pt-5">
                    <Row>
                        <Col sm="12" md="4" className="text-center">
                            <Paragraph paragraphKeywordArray={paragraph1KeywordArray} paragraph={paragraph1} type='underline' />
                        </Col>

                        <Col md="1" />

                        <Col sm="12" md="4" className="text-center">
                            <Paragraph paragraphKeywordArray={paragraph2KeywordArray} paragraph={paragraph2} type='underline' />
                        </Col>

                        <Col md="1" className="d-none d-md-block"></Col>

                        <Col md="2" className="d-none d-md-block">
                            <Row className="my-5">
                                <Col className="d-flex justify-content-end">
                                        <a 
                                        onMouseOver={() => handleHover(null, link1Description)}
                                        onMouseLeave={() => setShowPopover(false)} 
                                        href={twitterLink} 
                                        target="_blank" 
                                        rel="noopenner noreferrer" 
                                        className="text-success">
                                            <FontAwesomeIcon icon={faTwitter} size="3x" data-toggle="tooltip"
                                            data-placement="left"
                                            title="Link To My Twitter Page"/>       
                                        </a>
                                </Col>
                            </Row>

                            <Row className="my-5">
                                <Col className="d-flex justify-content-end">
                                        <a 
                                        onMouseOver={() => handleHover(null, link2Description)}
                                        onMouseLeave={() => setShowPopover(false)} 
                                        href={linkedinLink} 
                                        target="_blank" 
                                        rel="noopenner noreferrer" 
                                        className="text-success">
                                            <FontAwesomeIcon icon={faLinkedin} size="3x" data-toggle="tooltip"
                                            data-placement="left"
                                            title="Link To My Linkedin Page"/>
                                        </a>
                                </Col>
                            </Row>

                            <Row className="my-5">
                                <Col className="d-flex justify-content-end">
                                    <a href="https://google.com" className="text-success">
                                        <i className="fab fa-google fa-3x" data-toggle="tooltip"
                                        data-placement="left"
                                        title="Link To My Google Page"></i>
                                    </a>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                <Row>
                    <Col sm="9">
                            <CallToAction callToActionText={callToActionText} callToActionKeyword={callToActionKeyword} size='display-4' type='underline-lg' />
                            
                                <Button 
                                variant="warning" size="lg" href="#contact"
                                className="btn-shadow font-weight-bolder mb-5 mr-3 inner-link"
                                >
                                    <h3 className="font-weight-bolder text-uppercase m-0">{callToActionButtonText}</h3>
                                </Button>
                            
                                <Button variant="success" size="lg" href="#testimonials"
                                className="d-none d-md-inline-block btn-shadow font-weight-bolder mb-5 next-link1"
                                >
                                    <h3 className="font-weight-bolder text-uppercase m-0">{secondaryCallToActionButtonText}</h3>
                                </Button>
                            
                    </Col>

                    <Col 
                        style={{position: 'relative'}} 
                        onMouseOver={() => handleHover(headshotTitle,headshotDescription)}
                        onMouseLeave={() => setShowPopover(false)}
                        sm='3' 
                        className='justify-content-center'
                    >
                        <Img
                                fluid={headshot.fluid}
                                alt="Cami Ouzerdine"
                                width="200px"
                                height="200px"
                                className="my-1 d-block ml-auto rounded-circle cami-headshot"
                            />
                        {showPopover && (
                            <Popover 
                                popoverTitle={popoverTitle} 
                                popoverBody={popoverBody} 
                            />
                            )
                            }
                    </Col>
                </Row>
            </Container>
        </Container>
           
    </section>
    )
}

export default Mission
